import React from 'react';
import { Trans } from 'react-i18next';
import { Link, LinkProps } from 'react-router-dom';

interface OnboardingPageHelperLinkProps extends LinkProps {
  text?: string;
  i18nKey: string;
  to: string;
  target?: React.HTMLAttributeAnchorTarget;
}

export const OnboardingPageHelperLink: React.FC<OnboardingPageHelperLinkProps> = ({ i18nKey, to, ...delegated }) => {
  return (
    <div className='typography-body2 mt-5 text-center [text-wrap:balance]'>
      <Trans
        // @ts-ignore couldn't be bothered
        i18nKey={i18nKey}
        components={{
          Link: <Link to={to} className='underline' {...delegated} />,
          br: <br />,
        }}
      />
    </div>
  );
};
